import React from 'react';
import cc from 'classcat';
import { Field } from 'formik';
import styles from './radioButton.module.sass';
import { Text } from '../Text';
import { IconSVG } from '../SpriteSVG';
import { Icon } from '../Icon';

export const RadioButton = ({
  options,
  name,
  values,
  short,
  filter,
  actionOnClick,
  isPaidStep,
}) => (
  <div className={styles.radioGroup}>
    {!isPaidStep ? (
      <div
        className={cc([
          { [styles.radioGroupShort]: short },
          { [styles.radioGroupFilter]: filter },
        ])}
      >
        {options?.map(
          option =>
            option?.value && (
              <>
                <label>
                  <div
                    className={cc([
                      styles.radioButton,
                      {
                        [styles.radioButtonChecked]: values === option.value,
                        [styles.radioButtonFilter]: filter,
                      },
                    ])}
                  >
                    {option.gift && (
                      <div className={styles.gift}>+ подарок</div>
                    )}
                    <label>
                      <Field
                        className={styles.input}
                        type="radio"
                        name={name}
                        value={option.value}
                        onClick={() => {
                          if (actionOnClick) {
                            actionOnClick(option.value);
                          }
                        }}
                      />
                      <div className={styles.inputWrapper}>
                        {option.img ? (
                          <img
                            src="/icons/paySberpay.svg"
                            alt="Способ оплаты"
                          />
                        ) : (
                          option.icon && (
                            <Icon
                              icon={
                                <IconSVG
                                  name={option.icon}
                                  width={option.iconWidth}
                                  height={option.iconHeight}
                                />
                              }
                            />
                          )
                        )}
                        <div className={styles.inputBlock}>
                          <div>
                            <Text variant={'text'}>{option.label}</Text>
                          </div>
                          {option.labelTag ? (
                            <div className={styles.labelTag}>
                              {option.labelTag}
                            </div>
                          ) : (
                            <div>
                              <Text variant={'text-3'}>{option.subLabel}</Text>
                            </div>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                  {values === option.value && !short && (
                    <div className={styles.radioButtonDescription}>
                      <Text variant={'text'} color={'darkenColor'}>
                        {option.description}
                      </Text>
                    </div>
                  )}
                </label>
              </>
            ),
        )}
      </div>
    ) : (
      <div
        className={cc([
          { [styles.radioGroupShort]: short },
          { [styles.radioGroupFilter]: filter },
        ])}
      >
        {options.slice(0, 2)?.map(
          option =>
            option?.value && (
              <>
                <label>
                  <div
                    className={cc([
                      styles.radioButton,
                      {
                        [styles.radioButtonChecked]: values === option.value,
                        [styles.radioButtonFilter]: filter,
                      },
                    ])}
                  >
                    {option.gift && (
                      <div className={styles.gift}>+ подарок</div>
                    )}
                    <label>
                      <Field
                        className={styles.input}
                        type="radio"
                        name={name}
                        value={option.value}
                        onClick={() => {
                          if (actionOnClick) {
                            actionOnClick(option.value);
                          }
                        }}
                      />
                      <div className={styles.inputWrapper}>
                        {option.img ? (
                          <img
                            src="/icons/paySberpay.svg"
                            alt="Способ оплаты"
                          />
                        ) : (
                          option.icon && (
                            <Icon
                              icon={
                                <IconSVG
                                  name={option.icon}
                                  width={option.iconWidth}
                                  height={option.iconHeight}
                                />
                              }
                            />
                          )
                        )}
                        <div className={styles.inputBlock}>
                          <div>
                            <Text variant={'text'}>{option.label}</Text>
                          </div>
                          {option.labelTag ? (
                            <div className={styles.labelTag}>
                              {option.labelTag}
                            </div>
                          ) : (
                            <div>
                              <Text variant={'text-3'}>{option.subLabel}</Text>
                            </div>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                  {values === option.value && !short && (
                    <div className={styles.radioButtonDescription}>
                      <Text variant={'text'} color={'darkenColor'}>
                        {option.description}
                      </Text>
                    </div>
                  )}
                </label>
              </>
            ),
        )}
      </div>
    )}

    {isPaidStep && (
      options.slice(2)?.map(
        (option, index) =>
          option?.value && (
            <label key={`${option.value}-extra-${index}`}>
              <div
                style={{ margin: '16px 0 16px' }}
                className={cc([
                  styles.radioButton,
                  {
                    [styles.radioButtonChecked]: values === option.value,
                    [styles.radioButtonFilter]: filter,
                  },
                ])}
              >
                {option.gift && <div className={styles.gift}>+ подарок</div>}
                <Field
                  className={styles.input}
                  type="radio"
                  name={name}
                  value={option.value}
                  onClick={() => {
                    if (actionOnClick) {
                      actionOnClick(option.value);
                    }
                  }}
                />
                <div className={styles.inputWrapper}>
                  {option.img ? (
                    <img src="/icons/paySberpay.svg" alt="Способ оплаты" />
                  ) : (
                    option.icon && (
                      <Icon
                        icon={
                          <IconSVG
                            name={option.icon}
                            width={option.iconWidth}
                            height={option.iconHeight}
                          />
                        }
                      />
                    )
                  )}
                  <div className={styles.inputBlock}>
                    <Text variant={'text'}>{option.label}</Text>
                    {option.labelTag ? (
                      <div className={styles.labelTag}>{option.labelTag}</div>
                    ) : (
                      <Text variant={'text-3'}>{option.subLabel}</Text>
                    )}
                  </div>
                </div>
              </div>
              {values === option.value && !short && (
                <div className={styles.radioButtonDescription}>
                  <Text variant={'text'} color={'darkenColor'}>
                    {option.description}
                  </Text>
                </div>
              )}
            </label>
          )
      )
    )}

    {short &&
      options.map(dis => (
        <div>
          {values === dis.value && (
            <div className={styles.radioButtonDescription}>
              <Text variant={'text'} color={'darkenColor'}>
                {dis.description}
              </Text>
            </div>
          )}
        </div>
      ))}
  </div>
);
